import { Tooltip } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";
import { useCopyToClipboard } from "usehooks-ts";

import CodeBlockHighlighter from "../UI/CodeBlockHighlighter";
import {
  jsxExampleCodeEN,
  jsxExampleCodeRU,
  pythonExampleCodeEN,
  pythonExampleCodeRU,
} from "../../utils/constants";

const CopyIcon = require("../../assets/copy.png");
const TickIcon = require("../../assets/tick.png");

const InsructionBlock = () => {
  const [_, copy] = useCopyToClipboard();
  const [jsxCopied, setJsxCopy] = useState(false);
  const [pythonCopied, setPythonCopy] = useState(false);

  const { t, i18n } = useTranslation();

  const jsExample =
    i18n.language === "ru" ? jsxExampleCodeRU : jsxExampleCodeEN;
  const ptnExample =
    i18n.language === "ru" ? pythonExampleCodeRU : pythonExampleCodeEN;
  const copyInstruction = t("connectInstructionViewTooltip");

  return (
    <>
      <TopBox>{t("connectInstruction")}</TopBox>
      <BottomBox>
        <TitleContainer>
          <Title>{t("connectInstructionFirstStep")}</Title>
          <Description>
            {t("connectInstructionFirstDescription")}
            <br />
            {t("connectInstructionFirstDescriptionCode")}:
          </Description>
        </TitleContainer>
        <CodeBlockWrapper>
          <CopyContainer>
            <p>{t("connectInstructionView")}</p>
            <Tooltip
              placement="bottom"
              title={jsxCopied ? "" : copyInstruction}
              arrow
            >
              <CopyButton
                onClick={() => {
                  copy(jsExample);
                  setJsxCopy(true);
                  setTimeout(() => {
                    setJsxCopy(false);
                  }, 3000);
                }}
              >
                {jsxCopied ? (
                  <span>
                    <img src={TickIcon} alt="tick" />
                    {t("connectInstructionCopied")}
                  </span>
                ) : (
                  <span>
                    <img src={CopyIcon} alt="copy" />
                    {t("connectInstructionCopy")}
                  </span>
                )}
              </CopyButton>
            </Tooltip>
          </CopyContainer>
          <CodeBlockHighlighter language="jsx" code={jsExample} />
        </CodeBlockWrapper>
        <TitleContainer>
          <Title>{t("connectInstructionSecondtStep")}</Title>
          <Description>
            {t("connectInstructionSecondtDescription")}
            <br />
            {t("connectInstructionSecondtDescriptionCode")}:
          </Description>
        </TitleContainer>
        <CodeBlockWrapper>
          <CopyContainer>
            <p>{t("connectInstructionView")}</p>
            <Tooltip
              placement="bottom"
              title={pythonCopied ? "" : copyInstruction}
              arrow
            >
              <CopyButton
                onClick={() => {
                  copy(ptnExample);
                  setPythonCopy(true);
                  setTimeout(() => {
                    setPythonCopy(false);
                  }, 3000);
                }}
              >
                {pythonCopied ? (
                  <span>
                    <img src={TickIcon} alt="tick" />
                    {t("connectInstructionCopied")}
                  </span>
                ) : (
                  <span>
                    <img src={CopyIcon} alt="copy" />
                    {t("connectInstructionCopy")}
                  </span>
                )}
              </CopyButton>
            </Tooltip>
          </CopyContainer>
          <CodeBlockHighlighter language="python" code={ptnExample} />
        </CodeBlockWrapper>
      </BottomBox>
    </>
  );
};

export default InsructionBlock;

const TopBox = styled.div`
  margin-top: 40px;
  max-width: 54rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-top-right-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  background: #9bc2e0;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -2px rgb(0 0 0 / 5%);

  @media screen and (max-width: 767px) {
    max-width: 24rem;
  }
  @media screen and (max-width: 424px) {
    max-width: 18rem;
  }
`;

const BottomBox = styled.div`
  max-width: 54rem;
  min-height: 24rem;
  width: 100%;
  display: flex;
  padding: 2rem 1.5rem;
  flex-direction: column;
  gap: 15px;
  border: none;
  outline: none;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  color: #121212;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -2px rgb(0 0 0 / 5%);

  @media screen and (max-width: 767px) {
    max-width: 24rem;
  }
  @media screen and (max-width: 424px) {
    max-width: 18rem;
  }
`;

const TitleContainer = styled.div``;

const Title = styled.h4`
  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;

const Description = styled.p`
  font-size: 14px;
  margin-top: 5px;
  margin-left: 15px;

  @media screen and (max-width: 767px) {
    font-size: 12px;
  }
`;

const CodeBlockWrapper = styled.div``;

const CopyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background: #6ca6d3;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 12px;
  align-items: center;
  color: #fff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

const CopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #fff;

  span {
    display: flex;
    align-items: center;
    gap: 5px;

    img {
      width: 18px;
      height: 18px;
    }
  }
`;
